<template>
  <div class="succesNetpay">
    <success-netpay></success-netpay>
  </div>
</template>

<script>
// @ is an alias to /src
import successNetpay from "@/components/successNetpay.vue";

export default {
  name: "successNet",

  components: {
    successNetpay
  },
  created() {}
};
</script>


